import { useLayoutEffect } from "react";

import { lockBodyScroll, syncVisualViewportHeightVar } from "../methods/dom";

type UseMobileSheetViewportLockOptions = {
    isOpen: boolean;
    /** Mobile sheet: freeze body + viewport height sync. Desktop modal: overflow lock only. */
    freezeOnMobile: boolean;
    disableZoom?: boolean;
};

export const useMobileSheetViewportLock = ({
    isOpen,
    freezeOnMobile,
    disableZoom,
}: UseMobileSheetViewportLockOptions) => {
    useLayoutEffect(() => {
        if (!isOpen || typeof document === "undefined") {
            return;
        }

        const shouldDisableZoom = freezeOnMobile && disableZoom;

        const unlockScroll = lockBodyScroll({
            freezeOnMobile,
            disableZoom: shouldDisableZoom,
        });
        const unsyncViewport = freezeOnMobile
            ? syncVisualViewportHeightVar({
                  deferSessionStart: shouldDisableZoom,
              })
            : () => {};

        return () => {
            unlockScroll();
            unsyncViewport();
        };
    }, [disableZoom, freezeOnMobile, isOpen]);
};
